import React, { useEffect, useState } from 'react';
import { Pagination } from 'antd';
import type { PaginationProps } from 'antd';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

// 文章员工风采组件
const ArticleStaff: React.FC<{ staff: { id: number; cover_image:string, title: string; content: string; pub_date: string }[] }> = ({ staff }) => {
  const navigate = useNavigate();
  const handleClick = (id: number) => {
    navigate(`/staff/${id}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const extractFirstTwoParagraphs = (html: string) => {
    const matches  = html.match(/<p[^>]*>(.*?)<\/p>/g);
    if (matches) {
      return matches.slice(0, 2).join('');
    }
    return html;
  };
  const extractFirstImageSrc = (html: string) => {
    const match = html.match(/<img[^>]+src="([^">]+)"/);
    return match ? match[1] : null;
  };
  return (
    <div className="article-news">
      {staff.map((item) => (
        <div 
          key={item.id} 
          className="article-item mb-30"
          onClick={() => handleClick(item.id)}
          style={{ cursor: 'pointer' }}
        >
          {extractFirstImageSrc(item.content) && (
            <img src={extractFirstImageSrc(item.content)!} alt={item.title} className="article-image" />
          )}
          <div className="article-content">
            <h4 className="article-title">{item.title}</h4>
            <div className="article-text" dangerouslySetInnerHTML={{ __html: extractFirstTwoParagraphs(item.content) }} />
            <p className="article-date">{new Date(item.pub_date).toLocaleDateString()}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api';
const StaffPage: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === 'en';
  const [staff, setStaff] = useState<{ id: number; title: string; content: string;cover_image:string; pub_date: string; src: string }[]>([]);
  const [loading, setLoading] = useState(true);
  const currentStaff = staff.slice((currentPage - 1) * pageSize, currentPage * pageSize);
  useEffect(() => {
    const fetchStaff = async () => {
      setLoading(true);
      try {
        const response = await axios.get<{ 
          id: number; 
          title: string;
          title_en: string;
          cover_image: string; 
          content: string; 
          content_en: string;
          pub_date: string 
        }[]>(
           `${API_BASE_URL}/employees/`
        );
        const processedStaff = response.data.map(item => ({
          id: item.id,
          title: isEnglish && item.title_en ? item.title_en : item.title,
          content: isEnglish && item.content_en ? item.content_en : item.content,
          cover_image: '',
          pub_date: item.pub_date,
          src: ''
        }));
        setStaff(processedStaff);
      } catch (error) {
        console.error('Error fetching staff:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchStaff();
  }, [isEnglish]);
  const onChange: PaginationProps['onChange'] = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const itemRender: PaginationProps['itemRender'] = (_, type, originalElement) => {
    if (type === 'prev') {
      return <a>{isEnglish ? 'Previous' : '上一页'}</a>;
    }
    if (type === 'next') {
      return <a>{isEnglish ? 'Next' : '下一页'}</a>;
    }
    return originalElement;
  };
  if (loading) {
    return <div>{isEnglish ? 'Loading...' : '加载中，请稍候...'}</div>;
  }
  return (
    <div className="staff-page">
      <ArticleStaff staff={currentStaff} />
      <div className="text-center mt-30">
        <Pagination
          current={currentPage}
          pageSize={pageSize}
          total={staff.length}
          onChange={onChange}
          itemRender={itemRender}
          style={{justifyContent: 'center'}}
        />
      </div>
    </div>
  );
};

export default StaffPage; 